import { startOfWeek, addDays } from 'date-fns';
import { tenantTodayDate } from '../lib/calendar-date';

/**
 * Week-boundary helpers for the trucking dispatch calendar.
 *
 * The CalendarBooking / CalendarTruck interfaces, the `calendarTrucks` array
 * and the `calendarStats` object are gone: nothing imported any of them, and
 * the last two were an empty array and an all-zeros stats object left behind
 * when NewLoadBooking stopped reading them (see the two notes in that file).
 * A zeroed stats fixture is worth removing rather than keeping — it reads as a
 * measurement, and rendering it would have put "0% fleet utilization, 0
 * conflicts" on screen for a tenant nobody had measured.
 *
 * `formatDay` went with them; every screen that formats a day has its own,
 * and none of them imported this one.
 */

/**
 * Monday of the TENANT's current week (companies.time_zone), as a local-midnight
 * Date for the calendar grid — or null when the zone is unknown. The week used
 * to start from the device's today, so a laptop on UTC rolled the board to next
 * week on Sunday evening in Alberta.
 */
export function getCurrentWeekStart(timeZone: string | null): Date | null {
  const today = tenantTodayDate(timeZone);
  return today ? startOfWeek(today, { weekStartsOn: 1 }) : null;
}

export function getWeekDays(weekStart: Date): Date[] {
  return Array.from({ length: 7 }, (_, i) => addDays(weekStart, i));
}
